module.exports = __webpack_public_path__ + "img/oneimg.80d0e770.jpg";